<form [formGroup]="userForm">
  <markant-select
    *ngIf="userForm.controls['salutation'] as salutation"
    class="registration-form-select registration-form-input"
    style="width: 45%"
    id="salutation"
    name="salutation"
    required
    [options]="salutationOptions"
    [outlined]="outlined"
    [showLabelHint]="true"
    [label]="pathToTranslation + 'salutation' | transloco"
    [placeholder]="pathToTranslation + 'salutationPlaceholder' | transloco"
    [formControlName]="'salutation'"
    [error]="
      salutation.errors
        | formControlKeyError
          : pathToTranslation + 'salutationValidation'
          : showError || salutation.touched || salutation.dirty
        | transloco
    "
    [helper]="
      salutation.errors
        | formControlKeyError
          : pathToTranslation + 'salutationValidation'
          : showError || salutation.touched || salutation.dirty
        | transloco
    "
    (focusin)="pushVisitInputFieldEventToDataLayer('Anrede')"
  />

  <markant-input
    *ngIf="userForm.controls['firstname'] as firstName"
    class="registration-form-input"
    id="firstname"
    data-cy="input-firstname"
    name="firstname"
    required
    [outlined]="outlined"
    [showLabelHint]="true"
    [label]="pathToTranslation + 'firstname' | transloco"
    [formControlName]="'firstname'"
    [error]="
      firstName.errors
        | formControlError: showError || firstName.touched || firstName.dirty
    "
    [errorText]="
      firstName.errors
        | formControlKeyError
          : 'register.user.firstnameValidation'
          : showError || firstName.touched || firstName.dirty
        | transloco
    "
    (focusin)="pushVisitInputFieldEventToDataLayer('Vorname')"
  >
  </markant-input>

  <markant-input
    *ngIf="userForm.controls['lastname'] as lastname"
    class="registration-form-input"
    id="lastname"
    data-cy="input-lastname"
    name="lastname"
    required
    [outlined]="outlined"
    [showLabelHint]="true"
    [label]="pathToTranslation + 'lastname' | transloco"
    [formControlName]="'lastname'"
    [error]="
      lastname.errors
        | formControlError: showError || lastname.touched || lastname.dirty
    "
    [errorText]="
      lastname.errors
        | formControlKeyError
          : 'register.user.lastnameValidation'
          : showError || lastname.touched || lastname.dirty
        | transloco
    "
    (focusin)="pushVisitInputFieldEventToDataLayer('Nachname')"
  >
  </markant-input>
  <markant-input
    *ngIf="userForm.controls['email'] as email"
    class="registration-form-input"
    id="email"
    data-cy="input-email"
    name="email"
    required
    [outlined]="outlined"
    [showLabelHint]="true"
    [label]="pathToTranslation + 'email' | transloco"
    [formControlName]="'email'"
    [error]="
      email.errors | formControlError: showError || email.touched || email.dirty
    "
    [errorText]="
      email.errors
        | formControlKeyError
          : 'register.user.emailValidation'
          : showError || email.touched || email.dirty
        | transloco
    "
    (focusin)="
      pushVisitInputFieldEventToDataLayer('Geschäftliche E-Mail-Adresse')
    "
  >
  </markant-input>
</form>
